// Backwards compatibility
export * from 'primeng/types/panel';
export * from './panel';
export * from './style/panelstyle';
